import { api } from "../ConsumeApiController";
import CompanyRoutes from "../../apiRoutes/CompanyRoutes";

export async function GetEmployees() {
    try
    {
        const response = await api.get(CompanyRoutes.Employees.getAll);
        if(response.success === true)
            return {
                success:true, 
                employees:response.data,
                message: response.message
            }
        //return response.data;
    }
    catch (error)
    {
        console.error(error);
        return { success: false, message: 'Error de conexión' };
    }
}

export async function CreateEmployee(data) {
    try {
        // data debe incluir: first_name, last_name, position, etc.
        const response = await api.post(CompanyRoutes.Employees.create, data);
        return response;
    } catch (error) {
        return { success: false, message: 'Error al guardar empleado' };
    }
}

export async function UpdateEmployee(id, data) {
    try
    {
        const url = CompanyRoutes.Employees.update(id);
        const response = await api.put(url, data);
        return response;
    } catch (error) {
        return { success: false, message: 'Error al actualizar' };
    }
}

export async function DeleteEmployee(id) {
    try
    {
        const url = CompanyRoutes.Employees.delete(id);
        const response = await api.delete(url);
        return response;
    } catch (error) {
        return { success: false, message: 'Error al eliminar' };
    }
}